export class ExportarExcelAsignacionesDto {
	sede: string;
	ambiente: string;
	direccionIp: string;
	url: string;
	servidor: string;
	plataforma: string;
	rol: string;
	observaciones: string;
	compania: string;
	ciudad: string;
	servicio: string;
	usuarioSolicita: string;
	fechaSolicita: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/exportar-asignaciones-dto.ts